// Load environment variables from .env file
export const BASE_URL = import.meta.env.VITE_API_BASE_URL;
export const BASE_URL2 = import.meta.env.VITE_API_BASE_URL2;
export const FRONTEND_URL_PROD = import.meta.env.VITE_FRONTEND_URL_PROD;
export const FRONTEND_URL_DEV = import.meta.env.VITE_FRONTEND_URL_DEV;
export const FRONTEND_URL = import.meta.env.VITE_FRONTEND_URL;

/** Invite/deep-link origin: env in prod, window.location.origin in local Vite. */
export const getFrontendBaseUrl = () => {
  const fromEnv = String(
    FRONTEND_URL || FRONTEND_URL_DEV || FRONTEND_URL_PROD || ""
  ).trim();

  if (import.meta.env.DEV && typeof window !== "undefined") {
    return window.location.origin.replace(/\/$/, "");
  }

  if (fromEnv) {
    return fromEnv.replace(/\/$/, "");
  }

  if (typeof window !== "undefined") {
    return window.location.origin.replace(/\/$/, "");
  }

  return "";
};
